import {
    GET_STUDENT_STATS,
    GET_STUDENT_LIST,
    GET_STUDENT_AUTOCOMPLETE,
    ADD_STUDENT_SUCCESS,
    GET_STUDENT_PROFILE,
} from 'actions/studentManagement';

const initialState = {
    studentStats: {},
    studentList: [],
    studentListTotal: 0,
    studentAutocomplete: [],
    lastAddedStudent: null,
    studentProfile: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_STUDENT_STATS:
            return {
                ...state,
                studentStats: action.data,
            };
        case GET_STUDENT_LIST:
            return {
                ...state,
                studentList: Array.isArray(action?.data?.data)
                    ? action.data.data
                    : Array.isArray(action.data)
                        ? action.data
                        : [],
                studentListTotal: Number(
                    action?.data?.total ??
                    (Array.isArray(action.data) ? action.data.length : 0),
                ),
            };
        case GET_STUDENT_AUTOCOMPLETE:
            return {
                ...state,
                studentAutocomplete: Array.isArray(action.data) ? action.data : [],
            };
        case ADD_STUDENT_SUCCESS:
            return {
                ...state,
                lastAddedStudent: action.data,
            };
        case GET_STUDENT_PROFILE:
            return {
                ...state,
                studentProfile: action.data,
            };
        default:
            return {
                ...state,
            };
    }
};

export default reducer;
